import axios from "axios";

const BASEURL = "https://tv.dire.it/api";
// const BASEURL = "http://10.8.0.2:17004/api";

const apiClient = axios.create({
    baseURL: BASEURL,
    timeout: 10000,
});

export default {
    async getVideo(videoId) {
        try {
            const response = await apiClient.get(`/Videos/getvideo/${videoId}`);
            return response;
        } catch (error) {
            console.error("** API getVideo(videoId) - Error fetching video data:", error);
            throw error;
        }
    },
    async putVideoAddView(videoId) {
        try {
            const response = await apiClient.put(`/Videos/addview/${videoId}`);
            return response;
        } catch (error) {
            console.error("** API putVideoAddView(videoId) - Error adding views:", error);
            throw error;
        }
    },
};
